/*
 * @,@Author: ,: your name
 * @,@Date: ,: 2020-11-16 16:55:39
 * @,@LastEditTime: ,: 2021-02-18 09:27:26
 * @,@LastEditors: ,: Please set LastEditors
 * @,@Description: ,: In User Settings Edit
 * @,@FilePath: ,: \shoppingMall\src\webConfig.js
 */
let baseUrl;
let isDev = false;
let projectName = "YW"; //KYC/QYC/YW/WP (项目名称)
let envName = "test"; //test/pre/prod (环境名称)

if (isDev || process.env.NODE_ENV === "development") {
  // baseUrl = 'http://192.168.82.155:31001' // lei
  // baseUrl = 'http://192.168.84.167:31001'  //qing
  // baseUrl = 'http://192.168.83.167:31001'  //qing
  baseUrl = 'http://192.168.84.162:31001'  //chaozz
  // baseUrl = 'http://192.168.83.167:31001'  //chu
  // baseUrl = 'http://192.168.82.187:8080'  //rui
  // baseUrl = 'http://192.168.80.160:8080'  //rui
  // baseUrl = 'http://10.0.12.161:31001'  //chaozz

  // baseUrl = 'http://kytestadmin.shkf.weiputech.com/api' //测试/api' //测试
  // baseUrl = "http://qypreadmin.sh.weixice.com/api"; //企业测测试接口
  // baseUrl='http://kypreadmin.shkf.weiputech.com/api' //k yv
  // baseUrl='http://kytestadmin.sh.weixijiance.cn/api' //科研侧测测试外网
  // baseUrl = 'https://admin.weixice.com//api'
  // baseUrl='http://qytestadmin.sh.weixice.com/api'
  baseUrl = "http://yjpreadmin.shkf.weiputech.com/api";
    // baseUrl='http://www.yjwplab.com/api'
    // baseUrl='http://wppreadmin.sh.weipuceshi.cn/api'
  // baseUrl = "http://qiyeceadmin.sh.weixijiance.com/api";
  // baseUrl = "http://qytestadmin.sh.weixice.com/api";
} else if (process.env.NODE_ENV === "production") {
  baseUrl = "/api"; //线上测试、预发布、线上正式
}
export { isDev, baseUrl, projectName, envName };



// WEBPACK FOOTER //
// ./src/webConfig.js